import * as React from 'react';

import { SlateLeaf } from 'platejs/static';

export function CodeLeafStatic(props) {
  return (
    <SlateLeaf
      {...props}
      as="code"
      className="whitespace-pre-wrap rounded-md bg-muted px-[0.3em] py-[0.2em] font-mono text-sm">
      {props.children}
    </SlateLeaf>
  );
}
